import React , { Component } from 'react';
import close from '../../../assets/imgs/icon-close.svg'
import './FullScreenModal.scss';

const FullScreenModal = ({ children, isVisible, handleClose }) => {
  const display = isVisible ? 'flex' : 'none';

  return (
    <div className='modal-background' style={{ display }}>
      <div className="full-screen-modal" >
        {children}
        <img className="full-screen-modal__close" src={close} onClick={handleClose} alt='close-modal'/>
      </div>
    </div>
  )
}

export default FullScreenModal;
